import { getDraftSiteUrl } from "@/api/cms-puck/pages";
import { getPreviewToken } from "@/api/instance";

/**
 * Ouvre le site public en bypassant basic auth / maintenance via `?__preview=…`.
 * Ouvre l'onglet de façon synchrone (avant l'await) pour éviter le bloqueur de pop-up.
 * En cas d'erreur, retombe sur l'URL fournie sans token.
 */
export async function openPublicSiteWithBypass(
  fallbackFrontUrl = "",
): Promise<void> {
  const fallbackUrl = fallbackFrontUrl;
  const tab = window.open("", "_blank");
  try {
    const { token, frontUrl } = await getPreviewToken();
    const url = new URL(frontUrl || fallbackUrl);
    url.searchParams.set("__preview", token);
    if (tab) tab.location.href = url.toString();
    else window.open(url.toString(), "_blank");
  } catch {
    if (tab) tab.location.href = fallbackUrl;
    else if (fallbackUrl) window.open(fallbackUrl, "_blank");
  }
}

/**
 * Ouvre le site public en MODE APERÇU sous `/advanced-preview` : les brouillons
 * du CMS avancé — en-tête, pied de page, pages, menus — sont rendus à la place
 * du site publié, navigation site entier, pendant 3 h. L'URL (avec
 * `__advanced_draft`) est partageable avec le client final. Rien n'est publié :
 * les visiteurs continuent de voir le site en ligne. Porte aussi le bypass
 * basic auth. Ouverture d'onglet synchrone (anti-bloqueur), repli sur le site
 * publié.
 */
export async function openPublicSiteInDraftPreview(
  fallbackFrontUrl = "",
): Promise<void> {
  const tab = window.open("", "_blank");
  try {
    const { url } = await getDraftSiteUrl();
    if (tab) tab.location.href = url;
    else window.open(url, "_blank");
  } catch {
    if (tab) tab.location.href = fallbackFrontUrl;
    else if (fallbackFrontUrl) window.open(fallbackFrontUrl, "_blank");
  }
}
